import { useGetElearningCategoryQuery } from '@/modules/services';
import { ModuleSlideRoutes } from '@/pages/Module/routes';
import { ButtonCard, Card, Loader, Text } from 'elmo-elements';
import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { ContentManagerCategoryRoutes } from '../ContentManagerRoutes';

const PopOverDisplay = ({
  categoryId,
}: {
  categoryId: string;
}): React.ReactElement => {
  const history = useHistory();
  const { data: categoryData, isLoading: isCategoryDataLoading } =
    useGetElearningCategoryQuery([
      categoryId,
      { page: 1, limit: 5, order: 'ASC', sort: 'name' },
    ]);

  if (isCategoryDataLoading) {
    return <Loader type="list" className="pop-over-loader" />;
  }

  if (
    !categoryData ||
    !categoryData.elearnings ||
    categoryData.elearnings.length === 0 ||
    !categoryId
  ) {
    return <Card>No data available</Card>;
  }

  return (
    <div className="pop-over-modules">
      <Card className="pop-over-title">
        <Text htmlTag="strong">Go to Module</Text>
      </Card>
      {categoryData.elearnings.map((elearning) => (
        <ButtonCard
          key={elearning.id}
          title={elearning.name}
          onClick={() => {
            history.push(
              generatePath(ModuleSlideRoutes.path, {
                elearningId: elearning.id,
              }),
            );
          }}
        />
      ))}
      <ButtonCard
        className="view-all-btn"
        title="View All"
        onClick={() => {
          history.push(
            generatePath(ContentManagerCategoryRoutes.path, {
              categoryId,
            }),
          );
        }}
      />
    </div>
  );
};

export default PopOverDisplay;
